
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("aHEuK", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $7cad5500fbd391f6$export$2cd8252107eb640b; });

var $jG4hL = parcelRequire("jG4hL");

var $2mpqL = parcelRequire("2mpqL");

var $5PBbn = parcelRequire("5PBbn");
// ====================================================================================
// CSS
let $7cad5500fbd391f6$var$css = "/typo3conf/ext/as_template/Resources/Public/StyleSheets/Vendor/swiper-bundle.min.css";
if ((0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))('[href="' + $7cad5500fbd391f6$var$css + '"]').length === 0) (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("head").append('<link rel="stylesheet" type="text/css" href="' + $7cad5500fbd391f6$var$css + '">');
const $7cad5500fbd391f6$export$2cd8252107eb640b = function() {
    let attempts = 0;
    // if document.ready needed
    const whenComplete = ()=>{
        if (attempts > 30) return;
        attempts += 1;
        if (document.readyState === "complete") (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(".swiper-container--2").each(function() {
            let $this = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this);
            let cID = $this.attr("id");
            let id = $this.find(".swiper").attr("id");
            if (!$this.hasClass("swiper-container--light-arrows")) cID = $this.parents(".content-line").attr("id");
            let c2Slider = new (0, $2mpqL.default)(`#${id}`, {
                modules: [
                    (0, $5PBbn.Navigation),
                    (0, $5PBbn.Pagination),
                    (0, $5PBbn.Keyboard),
                    (0, $5PBbn.A11y)
                ],
                loop: true,
                speed: 500,
                spaceBetween: 30,
                setWrapperSize: true,
                navigation: {
                    nextEl: `#${cID} .swiper-button-next`,
                    prevEl: `#${cID} .swiper-button-prev`
                },
                pagination: {
                    el: `#${cID} .swiper-pagination`,
                    type: "bullets",
                    clickable: true
                },
                keyboard: {
                    enabled: true
                },
                a11y: {
                    enabled: true
                },
                on: {
                    afterInit: function(slider) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("#" + cID).addClass("slider-init");
                    }
                }
            });
        });
        else setTimeout(function() {
            whenComplete();
        }, 400);
    };
    whenComplete();
};

});

parcelRegister("jHMUv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e587f90d126edbfb$export$581ff339ea0ba762; });

var $5gKb4 = parcelRequire("5gKb4");
function $e587f90d126edbfb$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5gKb4._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("5gKb4", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $3d624443cd99befe$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $3d624443cd99befe$export$1e71eb4bef00f6b0; });
function $3d624443cd99befe$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hYccX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d15182816097eec3$export$4fa2f4023c9cbda5; });
function $d15182816097eec3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d15182816097eec3$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d15182816097eec3$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=container-2.module.4fbc4b44.js.map
